$(document).ready(function () {
    // Show/Hide Basic Tabs
    $('.tab-container .tabs-dropdown-list').on('change', function () {
        var element = $(this);
        var tabContainer = element.parents('.tab-container__tabs');

        tabContainer.find('.nav a').eq(element.val()).tab('show');
    });

    // Selects with URLs as the value
    $('.tab-container .tabs-dropdown-menu').on('change', function () {
        var url = $(this).val();
        if (url) {
            window.location = url;
        }
        return false;
    });

    // $('.hero__content .hero__casino-selector').on('change', function () {
    //     var url = $(this).val();
    //     if (url) {
    //         $('.hero__content .cta').click(function (){
    //            window.location = url;
    //         });
    //     }
    //     return false;
    // });

    // Show/Hide OSR Tabs
    $('.tab-container--osr .tabs-dropdown-tier-list').on('change', function () {
        var element = $(this);
        var tiertabContainer = element.parents('.tab-container--osr .tab-container__tabs');

        tiertabContainer.find('.nav a').eq(element.val()).tab('show');
    });

    // Set OSR Tiered Background & Border-Color
    $('.tab-container--osr .tabs-dropdown-tier-list').children().each(function () {
        var colors = ['#24325F', '#E5B94F', '#E1E1E1', '#A8B5CD'];
        $(this).attr('style', 'background-color:' + colors[$(this).val()] + '; border-color:' + colors[$(this).val()] + ';');
    });

    // Set OSR Tiered Dropdown Inverse Color Fix for Vynyl Status
    $('.tab-container--osr .tabs-dropdown-tier-list').change(function () {
        $(this).attr('style', $(this).find('option:selected').attr('style'));
        if ($(this).val() == 0) {
            $('select[id=dropdown-tier-list]').css('color', 'white');
            $('select[id=dropdown-tier-list]').addClass('dropdown--vinyl');
        } else {
            $('select[id=dropdown-tier-list]').css('color', '#191919');
            $('select[id=dropdown-tier-list]').removeClass('dropdown--vinyl');
        }
    }).change();


     // Set OSR Tiered Container Bottom-Border
     $('.tab-container--osr ul li a').click(function () {
        if ($(this).hasClass('nav-link--vinyl')) {
            $('.tab-container--osr .tab-content').css('border-color', '#24325F');
        } else if ($(this).hasClass('nav-link--gold')) {
            $('.tab-container--osr .tab-content').css('border-color', '#E5B94F');
        } else if ($(this).hasClass('nav-link--platinum')) {
            $('.tab-container--osr .tab-content').css('border-color', '#E1E1E1');
        } else {
            $('.tab-container--osr .tab-content').css('border-color', '#A8B5CD');
        }
    });
});
